export * from './file-upload-comunicacion.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/file-upload-comunicacion/index.ts